import { formatUuidT } from "../../../flatbuffers/display";

interface OrgSubtreeNode {
  id?: Parameters<typeof formatUuidT>[0];
  children?: OrgSubtreeNode[];
}

// Normalize a decoded child org's id to a formatted UUID string (matching the
// option values in SelectOrganizationsLight). Empty string when there is no id.
const formatChildId = (child: OrgSubtreeNode): string => {
  if (child.id == null) return "";
  return typeof child.id === "string" ? child.id : formatUuidT(child.id);
};

// Flatten the formatted UUIDs of every descendant (children, grandchildren, …)
// of a getOrganizationAndChilds payload. The setup wizard's parent picker uses
// this to hide the edited org's own subtree: reparenting an org under one of its
// descendants would create a cycle in the org tree (the backend rejects it too).
// The root org's own id is NOT included — the caller adds it separately.
const collectSubtreeIds = (org: OrgSubtreeNode | null | undefined): string[] => {
  const rawChildren = org?.children;
  const children = Array.isArray(rawChildren) ? rawChildren : [];
  return children.flatMap((child) => {
    const rest = collectSubtreeIds(child);
    const id = formatChildId(child);
    return id ? [id, ...rest] : rest;
  });
};

export default collectSubtreeIds;
